import React, { useState, useEffect, useRef } from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { Trans } from "react-i18next";
import Link from "../../components/Link";

import ArticleCardContainer from "../ArticleCardContainer";

import { convertSnakeToTitleCase } from "../../utils";
import useWindowPosition from "../../hooks/useWindowPosition";

const ArticleTemplate = ({
  relatedArticleTopic,
  relatedArticles,
  children,
  contentClassNames,
  childrenContainerClassNames,
  articleHeight,
}) => {
  const ref = useRef(null);
  const [articleIndexPositions, setArticleIndexPositions] = useState([]);
  const scrollPosition = useWindowPosition();

  //  Set parent prop state of article height for progressbar
  useEffect(() => {
    articleHeight(ref.current.clientHeight);
  });

  //  Find all article indexes from ref after wp loaded (1 sec delay)
  useEffect(() => {
    setTimeout(() => {
      const articleIndexPositionsTemp = [];
      const articleIndexes = document.querySelectorAll("h2[id^='header-c']");
      if (articleIndexes) {
        articleIndexes.forEach((articleIndex) => {
          articleIndexPositionsTemp.push(articleIndex.offsetTop);
        });
      }
      setArticleIndexPositions(articleIndexPositionsTemp);
    }, 1000);
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const diffArr = articleIndexPositions.map((x) =>
        Math.abs(scrollPosition - x)
      );
      const minNumber = Math.min(...diffArr);
      const index = diffArr.findIndex((x) => x === minNumber);

      document
        .querySelectorAll(
          `.table-of-contents--sticky ul#article-learn__index li a`
        )
        .forEach((tableIndex) => {
          tableIndex.parentElement.classList.remove("active");
        });
      if (index >= 0) {
        document
          .querySelector(
            `.table-of-contents--sticky ul#article-learn__index li a[href="#header-c${index}"]`
          )
          .parentElement.classList.add("active");
      }
    }
  }, [articleIndexPositions, scrollPosition]);

  return (
    <div className="article-template">
      <div
        className={cx(
          "article-template__wrapper container grid-container new-page-content py-5",
          contentClassNames
        )}
      >
        <div ref={ref} className={cx(childrenContainerClassNames)}>
          {children}
        </div>
      </div>

      {relatedArticleTopic && (
        <div className="article-template__related-articles container grid-container">
          <div className="grid-col-12 grid-col-lg-10 grid-offset-lg-2 d-flex justify-content-between mb-3">
            <h2>
              <Trans i18nKey={"article.relatedTopic"}>
                Related{" "}
                {{ topic: convertSnakeToTitleCase(relatedArticleTopic) }}
              </Trans>
            </h2>
          </div>
          <ArticleCardContainer
            classNames="grid-col-12 grid-col-lg-10 grid-offset-lg-2"
            posts={relatedArticles}
            topics={[relatedArticleTopic]}
            linkText={<Trans i18nKey={"common.learnMore"} />}
          />
          <div className="grid-col-12 mb-5 d-flex justify-content-center">
            <Link
              to={`/learn/filtration/?topic=${relatedArticleTopic}`}
              className="article-learn__btn-view-all"
            >
              <Trans i18nKey={"article.viewAllTopic"}>
                View all{" "}
                {{ topic: convertSnakeToTitleCase(relatedArticleTopic) }}
              </Trans>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

ArticleTemplate.propTypes = {
  relatedArticleTopic: PropTypes.string,
  relatedArticles: PropTypes.array,
  contentClassNames: PropTypes.string,
  childrenContainerClassNames: PropTypes.string,
  articleHeight: PropTypes.func,
};

ArticleTemplate.defaultProps = {
  childrenContainerClassNames: "grid-col-12 grid-col-lg-10 grid-offset-lg-2",
  articleHeight: () => void 0,
};

export default ArticleTemplate;
